<h3 class="ui primary header" style="text-transform: capitalize">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    appMargin="0"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <div
      class="ui basic segment"
      fxLayout="column"
      fxLayoutGap="15px"
      *ngIf="detail.director.companyName"
    >
      <div fxLayout="column" *ngIf="item == 'SHAREHOLDER_STRUCTURE'">
        <div>
          <p class="shareholderTopic">Shareholding Information</p>
          <div class="ui divider"></div>
        </div>
        <div fxLayout="column" style="margin-bottom: 15px">
          <div fxFlex>
            <div class="shareholderSubtitle">Shareholder Type</div>
          </div>
          <div fxFlex class="shareholderTitle">Company</div>
        </div>

        <div
          *ngIf="
            detail.director.companyName && detail.director.companyRegNumber
          "
          fxLayout="column"
          style="margin-bottom: 15px"
        >
          <div fxFlex>
            <div class="shareholderSubtitle">Company Name</div>
          </div>
          <div fxFlex class="shareholderTitle">
            {{ detail?.director?.companyName }}
          </div>
        </div>
        <div
          *ngIf="
            detail.director.companyName && detail.director.companyRegNumber
          "
          fxLayout="column"
          style="margin-bottom: 15px"
        >
          <div fxFlex>
            <div class="shareholderSubtitle">Company Registration Number</div>
          </div>
          <div fxFlex class="shareholderTitle">
            {{ detail?.director?.companyRegNumber }}
          </div>
        </div>

        <div fxLayout="column" style="margin-bottom: 15px">
          <div fxFlex>
            <div class="shareholderSubtitle">Allocated Shares</div>
          </div>
          <div fxFlex class="shareholderTitle">
            {{ detail?.director?.shareAllocated | number: "1.0-0" }}
          </div>
        </div>

        <div fxLayout="column" style="margin-bottom: 15px">
          <div fxFlex>
            <div class="shareholderSubtitle">Total Share Capital</div>
          </div>
          <div fxFlex class="shareholderTitle">
            {{ detail?.totalShareCapital?.totalShareCapital | number: "1.0-0" }}
          </div>
        </div>

        <div fxLayout="column" style="margin-bottom: 15px">
          <div fxFlex>
            <div class="shareholderSubtitle">Share Capital Percentage</div>
          </div>
          <div fxFlex class="shareholderTitle">
            {{ detail?.director?.shareholding }}%
          </div>
        </div>
      </div>

      <p class="shareholderHeading">Company Representative Information</p>
      <div>
        <p class="shareholderTopic">BIO DATA</p>
        <div class="ui divider"></div>
      </div>

      <div fxLayout="row">
        <div fxFlex>
          <img
            *ngIf="documentData"
            src="{{ documentData }}"
            class="ui mini image image-large"
          />
          <img
            *ngIf="!documentData"
            src="assets/avatar/1.jpg"
            class="ui circular tiny image"
          />
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Firstname</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.firstName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Lastname</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.lastName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Middlename</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.middleName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Gender</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.gender }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Address</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.address }}
        </div>
      </div>

      <div>
        <p class="shareholderTopic">Nationality</p>
        <div class="ui divider"></div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Nationality</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ filterResult(detail?.director?.nationalityId) }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Country of Origin</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ filterResult(detail?.director?.countryOfOriginId) }}
        </div>
      </div>

      <div appMargin marginB="15px" *ngIf="detail?.director?.nationalIdNumber">
        <div class="shareholderSubtitle">NATIONAL ID NUMBER</div>
        <div class="shareholderTitle">
          {{ detail?.director?.nationalIdNumber }}
        </div>
      </div>

      <div
        appMargin
        marginB="15px"
        *ngIf="detail?.director?.identificationNumber"
      >
        <div class="shareholderSubtitle">IDENTIFICATION NUMBER</div>
        <div class="shareholderTitle">
          {{ detail?.director?.identificationNumber }}
        </div>
      </div>

      <div class="item" style="margin-bottom: 15px">
        <h4 class="shareholderSubtitle">
          {{ data?.nationalityId === "NG" ? "NIN" : "IDENTIFICATION DOCUMENT" }}
        </h4>

        <div class="shareholderTitle">
          <div
            class="shareholder-file"
            *ngIf="detail?.director?.identificationDocument1Id"
          >
            <div
              class="added_document"
              *ngIf="detail?.director?.identificationDocument1Id"
            >
              <div
                class="contents"
                *ngIf="detail?.director?.identificationDocument1Id"
              >
                <div class="image">
                  <img src="assets/icons/Frame.svg" alt="" />
                </div>
                <div class="content_name">
                  <h5>{{ detail?.director?.identificationDocument1Id }}</h5>
                </div>
              </div>
              <div class="action_button">
                <img
                  src="assets/icons/Frame 5492.svg"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View"
                  (click)="
                    viewDocumentPath(
                      detail?.director?.identificationDocument1Path,
                      detail?.director?.identificationDocument1Id
                    )
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <div class="shareholderTitle">
          <div
            class="shareholder-file"
            *ngIf="detail?.director?.identificationDocument2Id"
          >
            <div
              class="added_document"
              *ngIf="detail?.director?.identificationDocument2Id"
            >
              <div
                class="contents"
                *ngIf="detail?.director?.identificationDocument2Id"
              >
                <div class="image">
                  <img src="assets/icons/Frame.svg" alt="" />
                </div>
                <div class="content_name">
                  <h5>{{ detail?.director?.identificationDocument2Id }}</h5>
                </div>
              </div>
              <div class="action_button">
                <img
                  src="assets/icons/Frame 5492.svg"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View"
                  (click)="
                    viewDocumentPath(
                      detail?.director?.identificationDocument2Path,
                      detail?.director?.identificationDocument2Id
                    )
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 10px">
        <p class="shareholderTopic">Contact Information</p>
        <div class="ui divider"></div>
      </div>
      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Email</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.email }}
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Phone Number</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.phoneNumber }}
        </div>
      </div>
    </div>

    <div
      class="ui basic segment"
      fxLayout="column"
      fxLayoutGap="15px"
      *ngIf="!detail.director.companyName"
    >
      <div>
        <p class="shareholderTopic">BIO DATA</p>
        <div class="ui divider"></div>
      </div>

      <div fxLayout="row">
        <div fxFlex>
          <img
            *ngIf="documentData"
            src="{{ documentData }}"
            class="ui mini image image-large"
          />
          <img
            *ngIf="!documentData"
            src="assets/avatar/1.jpg"
            class="ui circular tiny image"
          />
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Firstname</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.firstName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Lastname</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.lastName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Middlename</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.middleName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Gender</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.gender }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Address</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.address }}
        </div>
      </div>

      <div>
        <p class="shareholderTopic">Nationality</p>
        <div class="ui divider"></div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Nationality</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ filterResult(detail?.director?.nationalityId) }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Country of Origin</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ filterResult(detail?.director?.countryOfOriginId) }}
        </div>
      </div>

      <div appMargin marginB="15px" *ngIf="detail?.director?.nationalIdNumber">
        <div class="shareholderSubtitle">NATIONAL ID NUMBER</div>
        <div class="shareholderTitle">
          {{ detail?.director?.nationalIdNumber }}
        </div>
      </div>

      <div
        appMargin
        marginB="15px"
        *ngIf="detail?.director?.identificationNumber"
      >
        <div class="shareholderSubtitle">IDENTIFICATION NUMBER</div>
        <div class="shareholderTitle">
          {{ detail?.director?.identificationNumber }}
        </div>
      </div>

      <div class="item" style="margin-bottom: 15px">
        <h4 class="shareholderSubtitle">
          {{ data?.nationalityId === "NG" ? "NIN" : "IDENTIFICATION DOCUMENT" }}
        </h4>

        <div class="shareholderTitle">
          <div
            class="shareholder-file"
            *ngIf="detail?.director?.identificationDocument1Id"
          >
            <div
              class="added_document"
              *ngIf="detail?.director?.identificationDocument1Id"
            >
              <div
                class="contents"
                *ngIf="detail?.director?.identificationDocument1Id"
              >
                <div class="image">
                  <img src="assets/icons/Frame.svg" alt="" />
                </div>
                <div class="content_name">
                  <h5>{{ detail?.director?.identificationDocument1Id }}</h5>
                </div>
              </div>
              <div class="action_button">
                <img
                  src="assets/icons/Frame 5492.svg"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View"
                  (click)="
                    viewDocumentPath(
                      detail?.director?.identificationDocument1Path,
                      detail?.director?.identificationDocument1Id
                    )
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <div class="shareholderTitle">
          <div
            class="shareholder-file"
            *ngIf="detail?.director?.identificationDocument2Id"
          >
            <div
              class="added_document"
              *ngIf="detail?.director?.identificationDocument2Id"
            >
              <div
                class="contents"
                *ngIf="detail?.director?.identificationDocument2Id"
              >
                <div class="image">
                  <img src="assets/icons/Frame.svg" alt="" />
                </div>
                <div class="content_name">
                  <h5>{{ detail?.director?.identificationDocument2Id }}</h5>
                </div>
              </div>
              <div class="action_button">
                <img
                  src="assets/icons/Frame 5492.svg"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View"
                  (click)="
                    viewDocumentPath(
                      detail?.director?.identificationDocument2Path,
                      detail?.director?.identificationDocument2Id
                    )
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div fxLayout="column" *ngIf="item == 'SHAREHOLDER_STRUCTURE'">
        <div style="margin-top: 10px">
          <p class="shareholderTopic">Shareholding Information</p>
          <div class="ui divider"></div>
        </div>
        <div fxLayout="column" style="margin-bottom: 15px">
          <div fxFlex>
            <div class="shareholderSubtitle">Shareholder Type</div>
          </div>
          <div fxFlex class="shareholderTitle">Individual</div>
        </div>

        <div fxLayout="column" style="margin-bottom: 15px">
          <div fxFlex>
            <div class="shareholderSubtitle">Allocated Shares</div>
          </div>
          <div fxFlex class="shareholderTitle">
            {{ detail?.director?.shareAllocated | number: "1.0-0" }}
          </div>
        </div>

        <div fxLayout="column" style="margin-bottom: 15px">
          <div fxFlex>
            <div class="shareholderSubtitle">Total Share Capital</div>
          </div>
          <div fxFlex class="shareholderTitle">
            {{ detail?.totalShareCapital?.totalShareCapital | number: "1.0-0" }}
          </div>
        </div>

        <div fxLayout="column" style="margin-bottom: 15px">
          <div fxFlex>
            <div class="shareholderSubtitle">Share Capital Percentage</div>
          </div>
          <div fxFlex class="shareholderTitle">
            {{ detail?.director?.shareholding }}%
          </div>
        </div>
      </div>

      <div>
        <p class="shareholderTopic">Contact Information</p>
        <div class="ui divider"></div>
      </div>
      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Email</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.email }}
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex>
          <div class="shareholderSubtitle">Phone Number</div>
        </div>
        <div fxFlex class="shareholderTitle">
          {{ detail?.director?.phoneNumber }}
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
    <!-- <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Done</button> -->
  </div>
</div>
